import { useTranslation } from 'react-i18next';
import { entityColor } from '../../lib/atlasColors';
import { cn } from '../../lib/cn';

export default function MapLegend({ entities, visible, onToggle }) {
  const { t } = useTranslation();
  if (!entities || entities.length === 0) return null;

  // Deduplicate by name (support both Name and NAME from Cliopatria)
  const unique = [];
  const seen = new Set();
  for (const e of entities) {
    const name = e.Name || e.NAME;
    if (name && !seen.has(name)) {
      seen.add(name);
      unique.push({ ...e, _name: name });
    }
  }

  return (
    <div
      className={cn(
        'absolute bottom-20 right-4 z-10',
        'bg-white/95 dark:bg-gray-800/95 backdrop-blur-sm',
        'border border-gray-200 dark:border-gray-700',
        'rounded-lg shadow-lg overflow-hidden',
        'transition-all duration-200',
        visible ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0 pointer-events-none'
      )}
    >
      <div className="px-3 py-2 border-b border-gray-100 dark:border-gray-700 flex items-center justify-between">
        <span className="text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wide">
          {t('atlas.legend')}
        </span>
        <button
          onClick={onToggle}
          className="text-xs text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
        >
          {t('atlas.hide')}
        </button>
      </div>
      <div className="px-3 py-2 max-h-60 overflow-y-auto space-y-1">
        {unique.slice(0, 20).map((entity) => (
          <div key={entity._name} className="flex items-center gap-2">
            <div
              className="w-3 h-3 rounded-sm flex-shrink-0"
              style={{ backgroundColor: entityColor(entity._name), opacity: 0.7 }}
            />
            <span className="text-xs text-gray-700 dark:text-gray-300 truncate">
              {entity._name}
            </span>
          </div>
        ))}
        {unique.length > 20 && (
          <p className="text-xs text-gray-400 pt-1">
            +{unique.length - 20} {t('common.more')}
          </p>
        )}
      </div>
    </div>
  );
}
